import { CircularProgress } from '@mui/material';
import { initialAlertState, useAlertStatus } from '../../../../customHook/useAlertStatus';
import { AlertState } from '../../../../model/alerts.model';
import zeplinColor from '../../../../theme/Color';
import CustomAlert from '../../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../shared/CustomAlert/CustomAlertContain';
import { DocumentsTable } from './components/DocumentsTable';

export const Documents = () => {
  const { alertState, startOperation, completeOperation, setAlertState } = useAlertStatus();

  const getAlertContent = (alertState: AlertState) => {
    const { status, message } = alertState;

    let icon = null;
    if (status === 'in-progress') {
      icon = <CircularProgress sx={{ color: zeplinColor.Neutral1 }} size={'18px'} />;
    } else if (status === 'complete') {
      icon = (
        <img src='/assets/checkmark-green.png' width={24} height={24} alt='Operation successful' />
      );
    } else if (status === 'error') {
      icon = <img src='/assets/error.svg' width={24} height={24} alt='error message' />;
    }

    return <CustomAlertContain alertIcon={icon} alert={message} />;
  };

  return (
    <>
      <DocumentsTable startOperation={startOperation} completeOperation={completeOperation} />
      <CustomAlert
        open={alertState.status !== 'idle'}
        handleClose={() => setAlertState(initialAlertState)}
        message={getAlertContent(alertState)}
        error={alertState.status === 'error'}
      />
    </>
  );
};
